
import { Component, Prop, Vue } from 'vue-property-decorator'

import listModule from '@/store/list'
import authModule from '@/store/auth'
import companyModule from '@/store/company'
import venueModule from '@/store/venue'
import dealModule from '@/store/deal'
import {
  DealStatus,
  DealStatusText,
  Gender,
  GenderText,
  ListType
} from '@/utils/enums'
import { TextValue } from '@/types/Types'

@Component({
  name: 'FilterModal'
})
class FilterModal extends Vue {
  @Prop() readonly filters!: string[]
  @Prop() readonly headers!: TextValue[]
  @Prop() readonly type!: string
  @Prop() readonly storeModule!: any

  private dates: string[] = []
  private points: number[] = []
  private level: number[] = []
  private showMenu: { [key: string]: boolean } = {}

  private activeValues: [string, boolean][] = [
    ['Aktiv', true],
    ['Inaktiv', false]
  ]

  private get setFilters(): any {
    return listModule.filters
  }

  private get totalPages(): number {
    return listModule.totalPages
  }

  private set totalPages(val: number) {
    listModule.setTotalPages(val)
  }

  private async created() {
    if (this.type === ListType.VENUE || this.type === ListType.DEAL) {
      if (authModule.isSuperadmin || authModule.isAdmin) {
        await companyModule.fetchAll({ limit: 0, lean: true })
      }
      await venueModule.fetchAllCities()
    }
  }

  private filterLabel(filter: string): string | undefined {
    const label = this.headers.find(el => el.value === filter)
    if (label?.text) {
      return label.text
    }
    return undefined
  }

  private filterIsDate(filter: string): boolean {
    return filter.endsWith('Date') || filter === 'createdAt'
  }

  private filterIsRange(filter: string): boolean {
    return filter === 'points' || filter === 'level'
  }

  private filterItems(filter: string): any {
    // General filters with unique return values
    if (filter === 'company.name') {
      return companyModule.companies.map(el => [el.name, el._id])
    }

    if (filter === 'gender') {
      return Object.entries(Gender).map(entry => [
        GenderText[entry[0]],
        entry[1]
      ])
    }

    if (filter === 'active' || filter === 'enable') {
      return this.activeValues
    }

    // Specific filters with different return values, depending on list type
    if (this.type === ListType.COMPANY) {
      if (filter === 'type') {
        return companyModule.companyTypes
      }
    } else if (this.type === ListType.VENUE) {
      if (filter === 'address.city') {
        return venueModule.cities.map(el => [el, el])
      }
    } else if (this.type === ListType.DEAL) {
      if (filter === 'type') {
        return dealModule.dealTypes
      } else if (filter === 'status') {
        return Object.entries(DealStatus).map(entry => [
          DealStatusText[entry[0]],
          entry[1]
        ])
      }
    }
  }

  private async useFilters(): Promise<void> {
    this.totalPages = await this.storeModule.fetchAll({
      limit: listModule.perPage
    })

    document.dispatchEvent(new Event('close-filter'))
  }

  private updateFilters(key: string, value: string[]): void {
    if (
      (this.filterIsDate(key) || this.filterIsRange(key)) &&
      value.length < 2
    ) {
      value.push(value[0])
    }

    if (key === 'level') {
      // set points depending on set levels
      this.points[0] = parseInt(value[0]) * 6
      this.points[1] = parseInt(value[1]) * 6 + 5
      listModule.setFilterValue({ key: 'points', value: this.points })
    } else if (key === 'points') {
      // set levels depending on set points
      this.level[0] = Math.floor(parseInt(value[0]) / 6)
      this.level[1] = Math.floor(parseInt(value[1]) / 6)
      listModule.setFilterValue({ key, value })
    } else {
      listModule.setFilterValue({ key, value })
    }

    this.dates = []
    this.showMenu[key] = false
  }

  private resetFilters(): void {
    listModule.resetListValues()
    this.points = []
    this.level = []
    this.dates = []
  }
}

export default FilterModal
